import { format, parseISO } from "date-fns"

import type { Incentive } from "@/hooks/useIncentives"

import { ukDateOf, ukTimeOf } from "../../../shared/shift-timing.ts"

type Step = { label: string; by: string | null; at: string }

const formatInstant = (at: string) => {
  const instant = new Date(at)
  return `${format(parseISO(ukDateOf(instant)), "d MMM yyyy")}, ${ukTimeOf(instant)}`
}

// Only who created it and who set it live - the audit log has every other change.
const stepsOf = (incentive: Incentive): Step[] => [
  { label: "Created", by: incentive.created_by_name, at: incentive.created_at },
  ...(incentive.set_live ? [{ label: "Set live", ...incentive.set_live }] : []),
]

export default function IncentiveTimeline({ incentive }: { incentive: Incentive }) {
  const steps = stepsOf(incentive)
  return (
    <ol aria-label="Incentive history" className="mb-4">
      {steps.map((step, index) => (
        <li key={step.label} className="relative flex gap-3 pb-3 last:pb-0">
          {index < steps.length - 1 && (
            <span
              aria-hidden
              className="absolute -bottom-[5px] left-[4.5px] top-[15px] w-px bg-palette-jungleGreen200"
            />
          )}
          <span
            aria-hidden
            className="mt-[5px] h-2.5 w-2.5 shrink-0 rounded-full bg-palette-jungleGreen900"
          />
          <p className="text-sm text-palette-jungleGreen700">
            <span className="font-medium text-palette-jungleGreen900">{step.label}</span> by{" "}
            {step.by ?? "Unknown"} · <time dateTime={step.at}>{formatInstant(step.at)}</time>
          </p>
        </li>
      ))}
    </ol>
  )
}
